import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import { CtaNewsletterModule } from "@app/api/modules/cta-newsletter/cta-newsletter.module";
import { IconComponent, ImageComponent, ResourceTextComponent } from "@app/core";
import NewsletterArrow from "@assets/icons/newsletter-arrow.svg";
import {
  NewNewsletterFormComponent,
  INewNewsletterFormValues
} from "@app/core/newsletter/new-newsletter-form/new-newsletter-form.component";
import { subscribeToNewsletter } from "@app/redux/thunks/newsletter.thunk";
import { ReCaptcha } from "@app/core/recaptcha/recaptcha.component";
import { formatMessage } from "@app/translations/intl";

import styles from "./cta-newsletter-component.module.scss";

export interface ICtaNewsletterComponentProps {
  ctaNewsLetterModule: CtaNewsletterModule;
}

export const CtaNewsletterComponent = (props: ICtaNewsletterComponentProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [recaptchaToken, setRecaptchaToken] = React.useState("");
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const onSubmit = (values: INewNewsletterFormValues) => {
    if (values.emailAddress) {
      dispatch(subscribeToNewsletter(values, recaptchaToken));
      setIsSubmitted(true);
    }
  };

  return (
    <div className={styles.root}>
      <div className="uk-container">
        <div className={styles.center}>
          <div className={styles.wrapper}>
            {props.ctaNewsLetterModule.icon && (
              <div className={styles.paperIcon}>
                <ImageComponent src={props.ctaNewsLetterModule.icon} />
              </div>
            )}
            {props.ctaNewsLetterModule.ctaText && (
              <h4 className={styles.ctaText}>{props.ctaNewsLetterModule.ctaText}</h4>
            )}

            {props.ctaNewsLetterModule.icon && (
              <div className={styles.arrowIcon}>
                <IconComponent size="" icon={NewsletterArrow} />
              </div>
            )}

            <div className={styles.applyForm}>
              <ReCaptcha action="newsletter" callBackToken={setRecaptchaToken} />
              <NewNewsletterFormComponent intl={intl} onSubmit={onSubmit} isSubmitted={isSubmitted} />
            </div>
          </div>
          <p className={styles.infoText}>
            <ResourceTextComponent
              resourceKey="newsletterModalForm.infoText"
              values={{
                conditions: (
                  <Link rel="nofollow" to={formatMessage({ id: "global.conditionsLink" })}>
                    {formatMessage({ id: "newsletterModalForm.conditions" })}
                  </Link>
                )
              }}
            />
          </p>
        </div>
      </div>
    </div>
  );
};
